import { createSlice, Draft } from "@reduxjs/toolkit";
import { getPiggyEntityList, getPiggyProfilesList } from "./thunks";
import { PiggyEntity, PiggyProfile } from "../../entities/piggyGame";
import { ResponseMetaData } from "../../entities/global";

interface PiggyBankState {
  loading: boolean;
  needUpdateEntites: boolean;
  needUpdateProfiles: boolean;
  entities: PiggyEntity[];
  profiles: PiggyProfile[];
  metaEntities: ResponseMetaData;
  metaProfiles: ResponseMetaData;
}

const initialState: PiggyBankState = {
  loading: false,
  needUpdateEntites: true,
  needUpdateProfiles: true,
  entities: [],
  profiles: [],
  metaEntities: {
    limit: 250,
    page: 1,
    pages: 1,
    total: 0,
  },
  metaProfiles: {
    limit: 250,
    page: 1,
    pages: 1,
    total: 0,
  }
};

export const piggyBankTableSlice = createSlice({
  name: "piggyBankTable",
  initialState,
  reducers: {
    handlerNeedUpdate: (state: Draft<PiggyBankState>) => {
      state.needUpdateEntites = true;
    },
    handlerNeedUpdateProfiles: (state: Draft<PiggyBankState>) => {
      state.needUpdateProfiles = true;
    },
  },
  extraReducers: (builder) => {
    // getPiggyEntityList - получение списка игр
    builder.addCase(getPiggyEntityList.pending, (state) => {
      state.loading = true;
      state.needUpdateEntites = false;
    });
    builder.addCase(getPiggyEntityList.fulfilled, (state, action) => {
      const { data, ...meta } = action.payload
      state.entities = data;
      state.metaEntities = meta;
      state.loading = false;
    });
    // getPiggyProfilesList
    builder.addCase(getPiggyProfilesList.pending, (state) => {
      state.loading = true;
      state.needUpdateProfiles = false;
    });
    builder.addCase(getPiggyProfilesList.fulfilled, (state, action) => {
      const { data, ...meta } = action.payload
      state.profiles = data;
      state.metaProfiles = meta;
      state.loading = false;
    });
  },
});
// export actions
export const { handlerNeedUpdate, handlerNeedUpdateProfiles } = piggyBankTableSlice.actions;

export default piggyBankTableSlice.reducer;
